import { useFeatures } from 'modules/core/hooks/useFeatures'

import { AccountsListPageNew } from './AccountsListPageNew'
import { AccountsListPageOld } from './AccountsListPageOld'

const AccountsListPage = () => {
  const { has_dev_finance_accounts_datacollection: useDataCollection, loadingFeatures } =
    useFeatures(['dev_finance_accounts_datacollection'])

  // Show old implementation while loading or if flag is off
  if (loadingFeatures || !useDataCollection) {
    return <AccountsListPageOld />
  }

  return <AccountsListPageNew />
}

export default AccountsListPage
